<div class="pr-inner-container" id="innerContainer">
    <div class="py-3 text-base">
      @if (actionData()?.actionTypeId == ActionType.PurchaseRequisition) {
        @if(actionData()?.actionSubTypeId== ActionPRSubType.PRRequestSupplier){
          Supplier Sub-Request from Onsite Rental Group. Please review and take appropriate action.
        }
      }
    </div>
    <div class="body">
      <div class="body-container">
        <div class="supplier">
          <table class="table-fixed border-collapse border border-slate-400 w-full">
              <tbody>
                <tr>
                  <td>ABN</td>
                  <td>{{supplier()?.abn}}</td>
                </tr>
                <tr>
                  <td>Supplier Name</td>
                  <td>{{supplier()?.name}}</td>
                </tr>
              </tbody>
          </table>
        </div>

        <div class="creditor-code-sec" *ngIf="visibleCreditor">
          <!-- <ejs-textbox #creditorCode cssClass="e-outline h-10" class="creditor-code" maxLength="500" placeholder='Creditor Code' floatLabelType="Auto"
              id="creditorCode" height="30" [(ngModel)]="supplier().creditorCode">
          </ejs-textbox> -->
          <ejs-dropdownlist cssClass="e-outline" class="creditor-code" [(ngModel)]="supplier().creditorCode"
            [fields]='fields'
            id='creditorCode' #creditorCode [dataSource]='urlAdapterData' [placeholder]='ccPlaceholder'>
          </ejs-dropdownlist>
        </div>
        
      </div>
    </div>
    
    <div class="actions">
      <!-- <button class="btn btn-reject" (click)="onRejectClick($event)">
        <span class="e-icons e-circle-close-2"></span>
        <span class="text">Reject</span>
      </button> -->
      <button class="btn btn-approve" (click)="onApproveClick($event)" [disabled]="actionButton()?.disabledApproved">
        <span class="e-icons e-circle-check"></span>
        <span class="text">Approve</span>
      </button>
    </div>
</div>
